import React from 'react'
import {TbSchool} from 'react-icons/tb'
import { motion } from 'framer-motion';
import {fadeIn} from '../variants'

function Education() {
  return (
    <section className='section' id='education'>
        <div class="container mx-auto w-full h-full">
            <div class="relative wrap overflow-hidden p-10 h-full">
                <h2 className='text-center text-3xl mb-2'>Education</h2>
                <div class="border-2-2 absolute border-opacity-20 border-gray-700 h-full border" style={{left: '50%'}}></div>
                <div class="mb-8 flex justify-between items-center w-full right-timeline">
                     <div class="order-1 w-5/12"></div>
                     <div class="z-20 flex items-center order-1 bg-gray-800 shadow-xl w-8 h-8 rounded-full">
                       <h1 class="mx-auto font-semibold text-lg text-white"><TbSchool/></h1>
                     </div>
                     <motion.div variants={fadeIn('left',0.3)} 
                        initial='hidden' whileInView={"show"} 
                        viewport={{once:false,amount:0.3}} class="order-1 bg-gray-400 rounded-lg shadow-xl w-5/12 px-6 py-4">
                        <span className=' font-thin'>2022-Present</span>
                       <h3 class="mb-3 font-bold font-secondary text-gray-800 text-xl">INPT School of Engineering</h3>
                       <p class="text-sm leading-snug tracking-wide text-gray-900 text-opacity-100">Advanced Software Engineering for Digital services</p>
                     </motion.div>
                </div>
                <div class="mb-8 flex justify-between flex-row-reverse items-center w-full left-timeline">
                  <div class="order-1 w-5/12"></div>
                  <div class="z-20 flex items-center order-1 bg-gray-800 shadow-xl w-8 h-8 rounded-full">
                    <h1 class="mx-auto text-white font-semibold text-lg"><TbSchool/></h1>
                  </div>
                  <motion.div variants={fadeIn('right',0.3)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.3}} class="order-1 bg-gray-400 rounded-lg shadow-xl w-5/12 px-6 py-4">
                    <span className=' font-thin'>2020-2022</span>
                    <h3 class="mb-3 font-bold font-secondary text-gray-800 text-xl">Salmane Al Farissi CPGE</h3>
                    <p class="text-sm leading-snug tracking-wide text-gray-900 text-opacity-100">(TSI) Technology and Industrial Sciences</p>
                  </motion.div>
                </div>
                <div class="mb-8 flex justify-between items-center w-full right-timeline">
                  <div class="order-1 w-5/12"></div>
                  <div class="z-20 flex items-center order-1 bg-gray-800 shadow-xl w-8 h-8 rounded-full">
                    <h1 class="mx-auto font-semibold text-lg text-white"><TbSchool/></h1>
                  </div>
                  <motion.div variants={fadeIn('left',0.3)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.3}} class="order-1 bg-gray-400 rounded-lg shadow-xl w-5/12 px-6 py-4">
                  <span className='font-thin'>2019-2020</span>
                    <h3 class="mb-3 font-bold text-gray-800 text-xl">Prince Moulay Abdallah High School</h3>
                    <p class="text-sm leading-snug tracking-wide text-gray-900 text-opacity-100">Electrical Science and Technology</p>
                  </motion.div>
                </div>
                
            </div>
        </div>
    </section>
  )
}

export default Education